import { Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { type FilterItem } from '../../types';
import { Radios } from 'mui-rff';

type FilterRadioFieldProps = {
  item: FilterItem;
};

export const FilterRadioField = ({ item }: FilterRadioFieldProps) => {
  const fieldProps = item?.fieldProps ? item?.fieldProps : {};

  return (
    <Grid2 container direction="column">
      <Grid2>
        <Typography fontWeight={600} mb={1}>
          {item.label}
        </Typography>
      </Grid2>
      <Radios data={item.options} name={item.name} fieldProps={{ ...fieldProps }} />
    </Grid2>
  );
};
